import { TOWNER_TYPE_CODE, TPRIMARY_SOURCE_CODE } from '../types'

export const primSrcCdToLong = (primSource: TPRIMARY_SOURCE_CODE | '') => {
  switch (primSource) {
    case 'GW':
      return 'Ground Water'
    case 'GWP':
      return 'Ground Water Purchased'
    case 'SW':
      return 'Surface Water'
    case 'SWP':
      return 'Surface Water Purchased'
    case 'GU':
      return 'Groundwater under influence of surface water'
    case 'GUP':
      return 'Purchased ground water under influence of surface water source'
    default:
      return primSource
  }
}

export const ownerTypeCodeToLong = (ownerTypeCode: TOWNER_TYPE_CODE | '') => {
  switch (ownerTypeCode) {
    case 'F':
      return 'Federal Government'
    case 'L':
      return 'Local Government'
    case 'M':
      return 'Public/Private'
    case 'N':
      return 'Native American'
    case 'P':
      return 'Private'
    case 'S':
      return 'State Government'

  }
}
